import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 64;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <div className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden pt-16 pb-8" data-id="element-78">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-79">
        <img src="https://cdn.magicpatterns.com/uploads/rqCEc1YHGeYHvgFx39STF7/WhatsApp_Image_2026-02-22_at_13.31.13.jpg" alt="Música Background" className="w-full h-full object-cover" data-id="element-80" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-red-900/90" data-id="element-81" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white max-w-6xl flex flex-col items-center" data-id="element-82">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 backdrop-blur-sm border border-amber-400/50 rounded-full px-4 py-1.5 mb-4 animate-fade-in-up" data-id="element-83">
          <Star className="w-3.5 h-3.5 text-amber-400 fill-amber-400" data-id="element-84" />
          <span className="text-amber-200 font-semibold text-xs tracking-wide uppercase" data-id="element-85">
            El recurso #1 para docentes de música
          </span>
          <Star className="w-3.5 h-3.5 text-amber-400 fill-amber-400" data-id="element-86" />
        </div>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-black mb-4 leading-[1.1] drop-shadow-2xl" data-id="element-87">
          MegaPack de Música: <br data-id="element-88" />
          <span className="text-amber-400" data-id="element-89">Herramientas Completas</span>
        </h1>

        {/* Product Image Mockup */}
        <div className="relative w-full max-w-[240px] md:max-w-[280px] mx-auto perspective-1000 my-4" data-id="element-90">
          {/* Glow Effect */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[90%] bg-amber-500/25 blur-[100px] rounded-full opacity-60 animate-pulse-slow" data-id="element-91" />

          <img src="https://cdn.magicpatterns.com/uploads/2VPSo9GJNuWwGXTxEHefso/pasted-image.png" alt="MegaPack Música Lista - Vista previa del producto" className="relative z-10 w-full h-auto drop-shadow-2xl" style={{
          animation: 'float 6s ease-in-out infinite',
          filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.7))'
        }} data-id="element-92" />
        </div>

        <p className="text-base md:text-lg text-gray-100 mb-8 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-93">
          Planificaciones, actividades, dinámicas y proyectos listos para usar
          en el aula o talleres. Enseñá con más seguridad, orden y creatividad…
          desde hoy.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full max-w-xl" data-id="element-94">
          <a href="#comprar" className="w-full sm:w-auto" data-id="element-95">
            <Button size="lg" variant="primary" className="w-full sm:w-auto text-xl font-bold shadow-2xl shadow-red-900/40 px-10 py-4" data-id="element-96">
              Adquirir Ahora
              <ArrowRight className="ml-2 h-6 w-6" data-id="element-97" />
            </Button>
          </a>
          <Button size="lg" variant="secondary" onClick={() => scrollToSection('que-incluye')} className="w-full sm:w-auto text-xl font-bold bg-white/10 hover:bg-white/20 border-2 border-white/40 backdrop-blur-sm px-10 py-4" data-id="element-98">
            Más Información
          </Button>
        </div>
      </div>

      <style data-id="element-99">{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
          100% { transform: translateY(0px); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.6; }
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
      `}</style>
    </div>;
}